import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Progress
} from 'reactstrap';  
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { check, syncRequerimento, syncRequerimentoEncerrados } from "../../Services/RequerimentoService";
import { checkKey } from "../../Services/SecurityService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { util } from "../../../shared/util";

let notificationTC = null;

let estadosDivisa = new Map();
let totalRequerimentos = 0;
let contRequerimentos = 0;
let citiesName = null;
const LIMITE = 5;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
      canceled: false,

      processosVinculados: [],

      processingStatus: 0,
      processingStatusInfo: 1,
      tempoRestante: '',

      estados: {id:0},
      cidades: {id:0},
      list: []
    };
    check();

    this.process = this.process.bind(this);
  }

  process(requestList, index, length){
    let inicio = performance.now();
    let fim = 0;
    let diff = 0;
    let tempo = 0;
    let tempoRestante = "";
    syncRequerimento(requestList[index])
    .then(obj => {
      if(obj !== null && obj !== undefined){
        if(obj.erros === null || obj.erros === undefined || obj.erros.length === 0){

          contRequerimentos += requestList[index].cidadeList.length;
          let processingStatus = (contRequerimentos /  (totalRequerimentos+1)) * 100;

          fim = performance.now();
          diff = fim - inicio;
          tempo = diff * (((totalRequerimentos+1)-contRequerimentos)/LIMITE);
          tempoRestante = util.formatMiliseconds(tempo);

          // let processosVinculados = this.state.processosVinculados;
          // let cidade;
          // for(let i = 0; i < requestList[index].length; i++){
          //   cidade = citiesName.get(requestList[index][i]);
          //   processosVinculados.push(cidade.estado.uf + " - " + cidade.name + ": " + obj.syncs[i] + " requerimento(s)");
          // }
          this.setState({ processingStatus: processingStatus.toFixed(2), tempoRestante });

          if(index === length){
            console.log("syncRequerimento Finished");
            this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            setTimeout(
              () => this.props.updateTable(false), 
              1000
            );
          }else{
            if(!this.state.canceled){
              this.process(requestList, index+1, length);
            }
          }
          
        }else{
          this.setState({ clicked: false });
          console.log(obj.erros);
          this.show('danger', obj.erros);
        }
      } else {
        this.setState({ clicked: false });
        this.show('danger', this.props.t('forms.dataUpdateError'));
      }
    });
  }

  handleSubmit(e){
    // const { list } = this.state;
    this.setState({ clicked: true });
    let requestList = [];

    // citiesName = new Map();
    // let cities = this.getCities();
    let cities = this.state.cidades;

    totalRequerimentos = cities.length-1;
    contRequerimentos = -1;
    while(contRequerimentos < totalRequerimentos){
      let request = {
        cidadeList: []
      };
      if(contRequerimentos < 0){
        contRequerimentos++;
        request.cidadeList.push(cities[contRequerimentos]);
      }else{
        for(let g = 0; g < LIMITE; g++){
          contRequerimentos++;
          request.cidadeList.push(cities[contRequerimentos]);
          if(contRequerimentos + 1 > totalRequerimentos){
            break;
          }
        }
      }
      requestList.push(request);
    }
    contRequerimentos = 0;
    // console.log(requestList);
    console.log("syncRequerimento Started");
    this.process(requestList, 2, requestList.length-1);
  }

  getCities(){
    let ufs = [];
    let cities = [];
    let cityIds = [];
    let estado = [];
    for(let i = 0; i < this.state.list.length; i++){
      if(this.state.list[i].uf !== null && this.state.list[i].uf.length > 0){
        if(!ufs.includes(this.state.list[i].uf.toLowerCase())){
          ufs.push(this.state.list[i].uf.toLowerCase());
          // console.log(this.state.list[i].uf.toLowerCase());
          estado = estadosDivisa.get(this.state.list[i].uf.toLowerCase());
          // console.log(estado);
          // console.log(estado[0]);
          if(estado !== null && estado !== undefined){
            for(let j = 0; j < estado.length; j++){
              let states = this.state.estados.get(estado[j]);
              if(states !== null){
                for(let e = 0; e < states.cidades.length; e++){
                  if(!cityIds.includes(states.cidades[e].id)){
                    cities.push(states.cidades[e]);
                    cityIds.push(states.cidades[e].id);
                    citiesName.set(states.cidades[e].id, states.cidades[e]);
                  }
                }
              } 
            }
          }
        }
      }
    }
    return cities;
  }
  
  loadData(list, estados, cidades) {
    if(list !== undefined && list !== null && list.length > 0 && this.state.list.length === 0){
      this.setState({ list }, () => {});
    }
    // let ufs = [];
    // ufs.push("ba");ufs.push("se");ufs.push("al");ufs.push("pe");ufs.push("pi");ufs.push("to");ufs.push("go");ufs.push("mg");ufs.push("es");
    estadosDivisa.set("ba",["ba","se","al","pe","pi","to","go","mg","es"]);
    estadosDivisa.set("se",["se","ba","al"]);
    estadosDivisa.set("al",["al","ba","se","pe"]);
    estadosDivisa.set("pe",["pe","ba","al","pi","ce","pb"]);
    estadosDivisa.set("pi",["pi","ba","pe","to","ce","ma"]);
    estadosDivisa.set("to",["to","ba","pi","go","ma","pa","mt"]);
    estadosDivisa.set("go",["go","ba","to","mt","ms","mg"]);
    estadosDivisa.set("mg",["mg","ba","go","ms","sp","rj","es"]);
    estadosDivisa.set("es",["es","ba","mg","rj"]);
    
    if(estados !== undefined && estados !== null && this.state.estados.id !== undefined){
      this.setState({ estados }, () => {});
    }

    if(cidades !== undefined && cidades !== null && this.state.cidades.id !== undefined){
      this.setState({ cidades }, () => {});
    }
  }

  componentDidMount() {
    checkKey("MENU_REQUIREMENT_SYNC_CITY_PROCCESS");
    
    const { list, estados, cidades} = this.props;
    this.loadData(list, estados, cidades);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.list !== this.props.list || props.estados !== this.props.estados || props.cidades !== this.props.cidades){
      this.loadData(this.props.list, this.props.estados, this.props.cidades);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  clear(canceled){
    this.setState({ 
      estados: {},
      list: [],
      canceled
    }, () => {});
  }

  cancel(event) {
    this.clear(true);
    this.props.updateTable(false);
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    const { processosVinculados, clicked, processingStatus, processingStatusInfo, tempoRestante } = this.state;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form">

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.processingStatus') + " - " + t('forms.processingStatusInfo_requirements_'+processingStatusInfo) + ": " + processingStatus + " % (" + t('forms.timeLeft') + ": " + tempoRestante + ")"} 
                </span>
                <div key="div1" className="progress-wrap progress-wrap--big">
                  <Progress key="progress1" animated value={processingStatus} />
                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit"
                  onClick={e => this.handleSubmit(e)}
                  disabled={clicked}>
                  {t('forms.synchronize')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(CrudEdit);
